module.exports = __webpack_public_path__ + "static/media/Map A.85670e12.png";